import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { BusinessState } from '@state/business';

export const NotCollegeGuard: CanActivateFn = () =>
	!inject(Store).selectSnapshot(BusinessState.isCollege);
